import "./miniapp-demo.png";
import "./miniapp-icon.png";
import "./miniapp-text-b.png";
import "./miniapp-text.png";
import "./wxacode-b.png";
import "./wxacode-a.png";
import "./close.png";
require("./bottom-cover.less");